<app-recap [adminPage]="true" [showHeader]="false"></app-recap>

<!-- Selettore vista -->
<div class="mb-4 flex items-center justify-end">
    <div class="inline-flex gap-1 rounded-xl border border-solid border-slate-100 bg-white p-1 shadow-sm" role="group" aria-label="Vista della dashboard">
        <button type="button"
                class="inline-flex min-h-[34px] items-center gap-1.5 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="viewMode === 'list' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-50 hover:text-strong'"
                [attr.aria-pressed]="viewMode === 'list'" (click)="setViewMode('list')">
            <i class="bi bi-list-ul" aria-hidden="true"></i> Elenco
        </button>
        <button type="button"
                class="inline-flex min-h-[34px] items-center gap-1.5 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="viewMode === 'cards' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-50 hover:text-strong'"
                [attr.aria-pressed]="viewMode === 'cards'" (click)="setViewMode('cards')">
            <i class="bi bi-grid-1x2" aria-hidden="true"></i> Schede
            <span *ngIf="viewMode !== 'cards'" class="rounded-full px-1.5 py-px text-[10px] font-bold uppercase leading-tight"
                  style="background-color: rgba(var(--tertiary-rgb), 0.15); color: var(--tertiary-color);">Nuova</span>
        </button>
    </div>
</div>

<!-- ===================== Vista a schede ===================== -->
<div *ngIf="viewMode === 'cards'" class="relative mb-8 flex flex-col gap-6 text-strong">

    <!-- Da fare -->
    <section aria-labelledby="todo-title">
        <div class="mb-3 flex items-baseline justify-between gap-3">
            <h2 id="todo-title" class="m-0 text-xl font-semibold text-gray-900">Da fare</h2>
            <span class="text-sm text-slate-500" *ngIf="!countOf(lastPendingPaymentRegistration) && !countOf(companiesTable) && !countOf(agentTable)">
                Nessuna attività in sospeso
            </span>
        </div>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-payments', tone: 'tone-amber', icon: 'bi-cash-coin', label: 'Pagamenti da verificare', value: countOf(lastPendingPaymentRegistration)}"></ng-container>
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-companies', tone: 'tone-primary', icon: 'bi-building-check', label: 'Società da attivare', value: countOf(companiesTable)}"></ng-container>
            <ng-container *ngTemplateOutlet="todoTile; context: {target: 'card-pending-agents', tone: 'tone-tertiary', icon: 'bi-briefcase', label: 'Agenti da approvare', value: countOf(agentTable)}"></ng-container>
        </div>
    </section>

    <div class="grid gap-6 lg:grid-cols-2">
        <!-- Pagamenti da verificare -->
        <section id="card-pending-payments" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Pagamenti da verificare', subtitle: 'Bonifici e pagamenti in segreteria da confermare', count: countOf(lastPendingPaymentRegistration), icon: 'bi-cash-coin'}"></ng-container>
            <ul *ngIf="pendingPaymentRows.length; else emptyPendingPayments" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingPayments', pendingPaymentRows)" class="flex flex-col gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <div class="flex items-center gap-3">
                        <ng-container *ngTemplateOutlet="avatar; context: {image: row.athlete?.image, first: row.athlete?.firstName, last: row.athlete?.lastName}"></ng-container>
                        <div class="min-w-0 flex-1">
                            <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athlete?.firstName }} {{ row.athlete?.lastName }}</p>
                            <p class="m-0 truncate text-xs text-slate-500">
                                {{ row.category?.name }} · {{ getPaymentMethodLabel(row.athletePaymentRequest?.paymentMethod) }} · {{ row.athletePaymentRequest?.createdAt | date:'dd/MM/yyyy' }}
                            </p>
                        </div>
                        <strong class="shrink-0 text-sm font-semibold tabular-nums text-strong">{{ row.athletePaymentRequest?.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                    </div>
                    <div class="flex flex-wrap items-center justify-end gap-2">
                        <button type="button" class="dash-btn-ghost !text-red-600 hover:!bg-red-50 hover:!text-red-700" (click)="rejectAthletePayment(row.athletePaymentRequest.id)">Rifiuta</button>
                        <button type="button" class="dash-btn-primary" (click)="approveAthletePayment(row.athletePaymentRequest.id)">
                            <i class="bi bi-check-lg" aria-hidden="true"></i> Approva
                        </button>
                    </div>
                </li>
            </ul>
            <ng-template #emptyPendingPayments>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: lastPendingPaymentRegistration?.loading, text: 'Nessun pagamento da verificare.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingPayments', rows: pendingPaymentRows, table: lastPendingPaymentRegistration}"></ng-container>
        </section>

        <!-- Società in attesa di attivazione -->
        <section id="card-pending-companies" class="dash-section flex scroll-mt-6 flex-col">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Società da attivare', subtitle: 'Boarding completato, in attesa di attivazione', count: countOf(companiesTable), icon: 'bi-building-check'}"></ng-container>
            <ul *ngIf="pendingCompanyRows.length; else emptyPendingCompanies" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingCompanies', pendingCompanyRows)" class="flex flex-col gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <div class="flex items-center gap-3">
                        <img *ngIf="row.logoUrl; else companyInitials" [src]="row.logoUrl" alt=""
                             class="h-10 w-10 shrink-0 rounded-lg border border-solid border-slate-200 bg-white object-contain p-0.5"/>
                        <ng-template #companyInitials>
                            <span class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-slate-100 text-xs font-semibold text-slate-600">{{ initials(row.name, row.name?.split(' ')[1]) }}</span>
                        </ng-template>
                        <div class="min-w-0 flex-1">
                            <a [routerLink]="['/companies/' + row.id + '/settings']" class="m-0 block truncate text-sm font-semibold !text-strong hover:!text-primary">{{ row.name }}</a>
                            <p class="m-0 truncate text-xs text-slate-500">
                                {{ formatDateForTable(row.createdAt) }} · {{ row.agent ? (row.agent?.firstName + ' ' + row.agent?.lastName) : 'Nessun agente' }}
                            </p>
                        </div>
                        <span class="shrink-0 rounded-md px-2 py-0.5 text-xs font-semibold" [ngClass]="companyStatus(row.status).classes">{{ companyStatus(row.status).label }}</span>
                    </div>
                    <div class="flex flex-wrap items-center justify-end gap-2">
                        <ng-container *ngIf="row.status === 'pendingApprovation'; else onboardingAction">
                            <button type="button" class="dash-btn-ghost !text-red-600 hover:!bg-red-50 hover:!text-red-700"
                                    [disabled]="isCompanyApprovalBusy(row.id)" (click)="refuseCompany(row.id)">Rifiuta</button>
                            <button type="button" class="dash-btn-primary" [disabled]="isCompanyApprovalBusy(row.id)" (click)="approveCompany(row.id)">
                                <span *ngIf="isCompanyApprovalBusy(row.id)" class="spinner-border spinner-border-sm" style="width: 12px; height: 12px;" aria-hidden="true"></span>
                                <i *ngIf="!isCompanyApprovalBusy(row.id)" class="bi bi-check-lg" aria-hidden="true"></i> Attiva
                            </button>
                        </ng-container>
                        <ng-template #onboardingAction>
                            <button type="button" class="dash-btn-secondary" (click)="sendApprovalEmail(row.id)">
                                <i class="bi bi-envelope" aria-hidden="true"></i> Invia onboarding
                            </button>
                        </ng-template>
                    </div>
                </li>
            </ul>
            <ng-template #emptyPendingCompanies>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: companiesTable?.loading, text: 'Nessuna società in attesa di attivazione.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingCompanies', rows: pendingCompanyRows, table: companiesTable}"></ng-container>
        </section>

        <!-- Agenti in attesa di approvazione -->
        <section id="card-pending-agents" class="dash-section flex scroll-mt-6 flex-col lg:col-span-2">
            <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Agenti da approvare', subtitle: 'Agenti in attesa di attivazione', count: countOf(agentTable), icon: 'bi-briefcase'}"></ng-container>
            <ul *ngIf="pendingAgentRows.length; else emptyPendingAgents" class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let row of visibleRows('pendingAgents', pendingAgentRows)" class="flex items-center gap-3 px-5 py-4 transition hover:bg-slate-50/60">
                    <ng-container *ngTemplateOutlet="avatar; context: {image: row.image, first: row.firstName, last: row.lastName}"></ng-container>
                    <div class="min-w-0 flex-1">
                        <p class="m-0 truncate text-sm font-semibold text-strong">
                            {{ row.firstName }} {{ row.lastName }}
                            <span *ngIf="row.businessName" class="font-normal text-slate-500">· {{ row.businessName }}</span>
                        </p>
                        <p class="m-0 truncate text-xs text-slate-500">
                            <span *ngIf="row.vat">P. IVA {{ row.vat }} · </span>{{ row.email }}<span *ngIf="row.phone"> · {{ row.phone }}</span>
                        </p>
                    </div>
                    <button type="button" class="dash-btn-ghost !text-red-600 hover:!bg-red-50 hover:!text-red-700" (click)="rejectAgent(row.id)">Rifiuta</button>
                    <button type="button" class="dash-btn-primary" (click)="approveAgent(row.id)">Approva</button>
                </li>
            </ul>
            <ng-template #emptyPendingAgents>
                <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: agentTable?.loading, text: 'Nessun agente in attesa di approvazione.'}"></ng-container>
            </ng-template>
            <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'pendingAgents', rows: pendingAgentRows, table: agentTable}"></ng-container>
        </section>
    </div>

    <!-- Pagamenti -->
    <section class="dash-section">
        <ng-container *ngTemplateOutlet="cardHeader; context: {title: 'Pagamenti ricevuti', subtitle: 'Pagamenti degli atleti di tutte le società', count: countOf(paymentsList), icon: 'bi-wallet2'}"></ng-container>
        <form class="grid gap-2 border-0 border-b border-solid border-slate-100 px-5 py-3 md:grid-cols-[minmax(0,1fr)_13rem_16rem_auto] md:items-center" (ngSubmit)="filterSearch()">
            <label for="cards-athlete-filter" class="sr-only">Cerca atleta</label>
            <div class="relative min-w-0">
                <i class="bi bi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" aria-hidden="true"></i>
                <input id="cards-athlete-filter" type="search" name="cardsAthleteFilter" placeholder="Cerca per nome o cognome"
                       class="!m-0 !box-border !h-9 !w-full !rounded-lg !border !border-solid !border-slate-200 !bg-white !py-0 !pl-9 !pr-3 !text-sm !text-slate-800 !shadow-none focus:!border-primary focus:!outline-none"
                       [(ngModel)]="athleteTextFilter">
            </div>
            <label for="cards-method-filter" class="sr-only">Metodo di pagamento</label>
            <select id="cards-method-filter" name="cardsMethodFilter"
                    class="!m-0 !h-9 !w-full !rounded-lg !border !border-solid !border-slate-200 !bg-white !py-0 !pl-3 !text-sm !text-slate-800"
                    [(ngModel)]="selectedPaymentMethod" (ngModelChange)="filterSearch()">
                <option value="">Tutti i metodi</option>
                <option *ngFor="let method of paymentMethods" [ngValue]="method">{{ getPaymentMethodLabel(method) }}</option>
            </select>
            <div class="min-w-0">
                <welldone-multiselect
                        [placeholder]="'Tutte le società'" [data]="companies"
                        [(ngModel)]="selectedCompany" [ngModelOptions]="{standalone: true}"
                        [settings]="companySettings">
                </welldone-multiselect>
            </div>
            <div class="flex gap-2">
                <button type="submit" class="dash-btn-secondary !h-9 flex-1 justify-center md:flex-none">Cerca</button>
                <button *ngIf="athleteTextFilter || selectedPaymentMethod || selectedCompany?.length" type="button" class="dash-btn-ghost !h-9" (click)="resetFilters()">Azzera</button>
            </div>
        </form>
        <ul *ngIf="paymentRows.length; else emptyPayments" class="m-0 list-none divide-y divide-slate-100 p-0">
            <li *ngFor="let row of visibleRows('payments', paymentRows)" class="flex items-center gap-3 px-5 py-3 transition hover:bg-slate-50/60">
                <ng-container *ngTemplateOutlet="avatar; context: {image: row.athleteImage, first: row.athleteFirstName, last: row.athleteLastName}"></ng-container>
                <div class="min-w-0 flex-1">
                    <p class="m-0 truncate text-sm font-semibold text-strong">{{ row.athleteFirstName }} {{ row.athleteLastName }}</p>
                    <p class="m-0 truncate text-xs text-slate-500">
                        <span *ngIf="row.companyName" class="font-medium text-slate-600">{{ row.companyName }} · </span>{{ row.categoryName }} · {{ getPaymentMethodLabel(row.paymentMethod) }} · {{ row.createdAt }}
                    </p>
                </div>
                <span class="hidden shrink-0 rounded-md px-2 py-0.5 text-xs font-semibold sm:inline" [ngClass]="paymentStatus(row.status).classes">{{ paymentStatus(row.status).label }}</span>
                <strong class="shrink-0 text-sm font-semibold tabular-nums text-strong">{{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                <div class="flex w-[76px] shrink-0 items-center justify-end gap-1">
                    <ng-container *ngIf="row.paymentMethod === 'transfer' || row.paymentMethod === 'localPayment'">
                        <button type="button" class="dash-btn-icon" title="Modifica importo" aria-label="Modifica importo" (click)="openEditModal(row)">
                            <i class="bi bi-pencil" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="dash-btn-icon hover:!bg-red-50 hover:!text-red-600" title="Elimina pagamento" aria-label="Elimina pagamento" (click)="deletePayment(row.id)">
                            <i class="bi bi-trash" aria-hidden="true"></i>
                        </button>
                    </ng-container>
                </div>
            </li>
        </ul>
        <ng-template #emptyPayments>
            <ng-container *ngTemplateOutlet="cardEmpty; context: {loading: paymentsList?.loading, text: 'Nessun pagamento trovato.'}"></ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="cardFooter; context: {section: 'payments', rows: paymentRows, table: paymentsList}"></ng-container>
    </section>
</div>

<ng-template #todoTile let-target="target" let-tone="tone" let-icon="icon" let-label="label" let-value="value">
    <button type="button" (click)="scrollToCard(target)"
            class="dash-tile group flex min-w-0 cursor-pointer items-center gap-4 p-4 text-left sm:p-5" [ngClass]="tone">
        <span class="dash-icon grid h-12 w-12 shrink-0 place-items-center text-2xl sm:h-14 sm:w-14">
            <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
        </span>
        <span class="min-w-0">
            <span class="dash-label mb-1 block text-[11px] font-bold uppercase leading-tight tracking-wide">{{ label }}</span>
            <span class="dash-value block text-[1.6rem] font-extrabold leading-tight">{{ value }}</span>
        </span>
    </button>
</ng-template>

<!-- Foto profilo con iniziali come fallback -->
<ng-template #avatar let-image="image" let-first="first" let-last="last">
    <img *ngIf="image; else avatarInitials" [src]="image" alt=""
         class="h-10 w-10 shrink-0 rounded-full border border-solid border-slate-200 object-cover"/>
    <ng-template #avatarInitials>
        <span class="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600">{{ initials(first, last) }}</span>
    </ng-template>
</ng-template>

<ng-template #cardHeader let-title="title" let-subtitle="subtitle" let-count="count" let-icon="icon">
    <header class="flex items-center gap-3 border-0 border-b border-solid border-slate-100 px-5 py-4">
        <span class="grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-solid border-slate-200 text-base text-slate-500">
            <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
        </span>
        <div class="min-w-0 flex-1">
            <h3 class="m-0 flex items-center gap-2 text-[15px] font-semibold text-gray-900">
                {{ title }}
                <span *ngIf="count" class="rounded-md bg-slate-100 px-1.5 py-0.5 text-xs font-semibold leading-none text-slate-600">{{ count }}</span>
            </h3>
            <p class="m-0 truncate text-xs text-slate-500">{{ subtitle }}</p>
        </div>
    </header>
</ng-template>

<ng-template #cardEmpty let-loading="loading" let-text="text">
    <div *ngIf="loading" class="flex animate-pulse flex-col gap-2 p-5" role="status" aria-label="Caricamento">
        <div class="h-10 rounded-lg bg-slate-100"></div>
        <div class="h-10 rounded-lg bg-slate-100"></div>
    </div>
    <p *ngIf="!loading" class="m-0 flex flex-1 items-center justify-center px-5 py-6 text-center text-sm text-slate-500">{{ text }}</p>
</ng-template>

<ng-template #cardFooter let-section="section" let-rows="rows" let-table="table">
    <footer *ngIf="rows.length > cardPreviewSize || (table && table.pagesCount > 1 && expandedCardSections.has(section))"
            class="mt-auto flex items-center justify-between gap-3 border-0 border-t border-solid border-slate-100 px-5 py-2">
        <button *ngIf="rows.length > cardPreviewSize" type="button" class="dash-btn-ghost" (click)="toggleCardSection(section)">
            {{ expandedCardSections.has(section) ? 'Mostra meno' : 'Mostra tutti (' + (table?.totalCount || rows.length) + ')' }}
            <i class="bi" [ngClass]="expandedCardSections.has(section) ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
        </button>
        <div *ngIf="table && table.pagesCount > 1 && expandedCardSections.has(section)" class="ml-auto flex items-center gap-1 text-xs text-slate-500">
            <button type="button" class="dash-btn-icon" [disabled]="table.currentPage === 0 || table.loading" (click)="table.previousPagePagination()" aria-label="Pagina precedente">
                <i class="bi bi-chevron-left" aria-hidden="true"></i>
            </button>
            <span class="tabular-nums">{{ table.currentPage + 1 }} / {{ table.pagesCount }}</span>
            <button type="button" class="dash-btn-icon" [disabled]="table.currentPage >= table.pagesCount - 1 || table.loading" (click)="table.nextPagePagination()" aria-label="Pagina successiva">
                <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
        </div>
    </footer>
</ng-template>

<div class="modal fade show" tabindex="-1" *ngIf="selectedPayment" style="display:block; background: rgba(0,0,0,0.5);">

    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Dettaglio Pagamento</h5>
                <button type="button" class="btn-close" (click)="closeEditModal()">
                </button>
            </div>

            <div class="modal-body">

                <div class="mb-3">
                    <label class="form-label">
                        <b>Atleta</b>:
                        {{ selectedPayment?.athleteFirstName }}
                        {{ selectedPayment?.athleteLastName }}
                    </label>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        <b>Metodo di pagamento</b>:
                        {{ getPaymentMethodLabel(selectedPayment?.paymentMethod) }}
                    </label>
                </div>

                <div class="mb-3 d-flex align-items-center gap-2">
                    <label class="form-label mb-0"><b>Importo</b>:</label>
                    <input type="number" class="form-control w-auto" [(ngModel)]="editAmount" min="0">
                </div>

            </div>

            <div class="modal-footer">
                <button class="btn btn-secondary" (click)="closeEditModal()">
                    Annulla
                </button>

                <button class="btn btn-primary" (click)="confirmEdit()">
                    Salva
                </button>
            </div>

        </div>
    </div>
</div>


<!-- ===================== Vista elenco (classica) ===================== -->
<!-- Le tabelle restano montate anche nella vista a schede: caricano i dati usati da entrambe. -->
<div [hidden]="viewMode !== 'list'">

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom" (click)="collapsePendingPayments = !collapsePendingPayments">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Pagamenti da approvare</span>
            <span class="table-desc-custom mt-1">Riepilogo delle ultime iscrizioni effettuate e da confermare il pagamento.</span>
        </div>
        <i class="bi" [ngClass]="collapsePendingPayments ? 'bi-chevron-down' : 'bi-chevron-up'" style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapsePendingPayments">
        <ui-table #lastPendingPaymentRegistration class="no-box-model">
    <ng-template #customHeader>
        <tr>
            <th>Nome</th>
            <th>Categoria</th>
            <th>Importo</th>
            <th>Metodo di pagamento</th>
            <th>Stato del pagamento</th>
            <th>Data del pagamento</th>
        </tr>
    </ng-template>
    <ng-template #customLoading>
            <div class="py-4">
                <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-4 px-4">
                        <div class="h-4 w-48 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-4 w-24 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                    </div>
                    <div class="flex items-center gap-4 px-4">
                        <div class="h-4 w-40 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                    </div>
                </div>
            </div>
            <div class="py-4">
                <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-4 px-4">
                        <div class="h-4 w-48 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-4 w-24 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                    </div>
                    <div class="flex items-center gap-4 px-4">
                        <div class="h-4 w-40 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                        <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                    </div>
                </div>
            </div>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>
                {{ row.athlete.firstName }} {{ row.athlete.lastName }}
            </td>
            <td>
                {{ row.category.name }}
            </td>
            <td>
                {{ row.athletePaymentRequest.amount | number:'':'it' }}€
            </td>
            <td>
                {{
                    row.athletePaymentRequest.paymentMethod === 'localPayment' ? 'Pagamento in segreteria' :
                        (row.athletePaymentRequest.paymentMethod === 'transfer' ? 'Bonifico bancario' :
                            row.athletePaymentRequest.paymentMethod)
                }}
            </td>

            <td>
                <span *ngIf="row.athletePaymentRequest.status === 'paid' " class="badge badge-success"> Pagato </span>
                <span *ngIf="row.athletePaymentRequest.status === 'pendingPayment'" class="badge badge-warning"> In
                    attesa del pagamento</span>
                <span *ngIf="row.athletePaymentRequest.status === 'notPaid'" class="badge badge-error">Errore
                    pagamento</span>
            </td>
            <td>
                {{ row.athletePaymentRequest.createdAt | date:'dd/MM/yyyy' }}
            </td>

        </tr>
    </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom" (click)="collapsePaymentsList = !collapsePaymentsList">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Gestione Pagamenti Atleti</span>
            <span class="table-desc-custom mt-1">Riepilogo dei pagamenti effettuati dagli atleti.</span>
        </div>
        <i class="bi" [ngClass]="collapsePaymentsList ? 'bi-chevron-down' : 'bi-chevron-up'" style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapsePaymentsList">
        <ui-table #paymentsList class="no-box-model">
    <ng-template #customFilter>
        <div class="row">

            <div class="col-4">
                <label for="athleteFilter" class="form-label">Nome / Cognome Atleta</label>
                <input type="text" class="form-control" id="athleteFilter" [(ngModel)]="athleteTextFilter"
                       [ngModelOptions]="{ standalone: true }">
            </div>

            <div class="col-4">
                <label for="paymentMethod" class="form-label">Metodo di Pagamento</label>
                <select class="form-control form-control-solid" id="paymentMethod"
                        [(ngModel)]="selectedPaymentMethod">
                    <option value="">Tutti</option>
                    <option *ngFor="let method of paymentMethods" [ngValue]="method">
                        {{ getPaymentMethodLabel(method) }}
                    </option>
                </select>
            </div>

            <div class="col-4">
                <label class="form-label">Società</label>
                <welldone-multiselect
                        [placeholder]="'Cerca il nome di una società'" [data]="companies"
                        [(ngModel)]="selectedCompany"
                        [settings]="companySettings">
                </welldone-multiselect>
            </div>

            <div class="col-12 text-right">
                <div style="margin-top: 10px;">
                    <button class="btn btn-default pull-right" (click)="resetFilters()">Reset</button>
                    <button class="btn btn-primary pull-right" (click)="filterSearch()">Cerca</button>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #customHeader>
        <tr>
            <th>Atleta</th>
            <th>Metodo di Pagamento</th>
            <th>Categoria</th>
            <th>Società sportiva</th>
            <th>Importo</th>
            <th>Stato</th>
            <th>Data</th>
            <th class="text-right">Azioni</th>
        </tr>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>{{ row.athleteFirstName + ' ' + row.athleteLastName }}</td>
            <td><span>{{ getPaymentMethodLabel(row.paymentMethod) }}</span></td>
            <td><span>{{ row.categoryName }}</span></td>
            <td><span>{{ row.companyName }}</span></td>
            <td>
                <ng-container *ngIf="editingPaymentId !== row.id; ">
                    {{ row.amount | currency:'EUR':'symbol':'1.2-2':'it' }}
                </ng-container>
            </td>
            <td>
                <span *ngIf="row.status === 'paid'" class="badge badge-success"> Pagato</span>
                <span *ngIf="row.status === 'verifying payment'" class="badge badge-warning"> Verifica pagamento</span>
                <span *ngIf="row.status !== 'paid' && row.status !== 'verifying payment'"
                      class="badge badge-danger">{{ row.status }} </span>
            </td>
            <td><span>{{ row.createdAt }}</span></td>
            <td class="text-right">
                <div class="d-flex justify-content-end">
                    <button class="btn welldone-btn me-2"
                            [hidden]="!(row.paymentMethod === 'transfer' || row.paymentMethod === 'localPayment')"
                            (click)="openEditModal(row)" title="Modifica importo">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button type="button"
                            class="btn welldone-btn d-flex align-items-center justify-content-center"
                            [hidden]="!(row.paymentMethod === 'transfer' || row.paymentMethod === 'localPayment')"
                            (click)="deletePayment(row.id)" title="Elimina pagamento">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom" (click)="collapseCompaniesTable = !collapseCompaniesTable">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Società in attesa di attivazione</span>
            <span class="table-desc-custom mt-1">In questa lista ci sono tutte le società che hanno completato il boarding e una volta ricevuto il pagamento possiamo attivare.</span>
        </div>
        <i class="bi" [ngClass]="collapseCompaniesTable ? 'bi-chevron-down' : 'bi-chevron-up'" style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseCompaniesTable">
        <ui-table #companiesTable class="no-box-model">
    <ng-template #customLoading>
        <div class="py-4">
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-4 px-4">
                    <div class="h-4 w-40 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-32 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-24 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                </div>
                <div class="flex items-center gap-4 px-4">
                    <div class="h-4 w-44 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-32 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-20 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #customHeader>
        <tr>
            <th>Ragione Sociale</th>
            <th>Data boarding</th>
            <th>Agente</th>
            <th>Stato</th>
            <th scope="col" class="flex justify-end px-4"> Azioni</th>
        </tr>
    </ng-template>
    <ng-template #customLoading>
        <div class="py-4">
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-4 px-4">
                    <div class="h-4 w-40 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-32 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-24 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                </div>
                <div class="flex items-center gap-4 px-4">
                    <div class="h-4 w-44 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-28 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-32 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-4 w-20 rounded-full bg-slate-200 animate-pulse"></div>
                    <div class="h-8 w-24 rounded-full bg-slate-200 animate-pulse ml-auto"></div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>
                <a [routerLink]="['/companies/' + row.id + '/settings']" class="company-name">
                    {{ row.name }}
                </a>
            </td>
            <td>
                {{ formatDateForTable(row.createdAt) }}
            </td>
            <td>
                {{ row.agent ? (row.agent?.firstName + ' ' + row.agent?.lastName) : 'Nessun agente' }}
            </td>
            <td>
                <div *ngIf="row.status === 'pendingApprovation'" class="badge badge-warning">
                    In attesa di approvazione
                </div>
                <div *ngIf="row.status === 'pendingOnboarding'" class="badge badge-warning">
                    In attesa di onboarding
                </div>
                <div *ngIf="row.status === 'active'" class="badge badge-success">
                    Approvata
                </div>
            </td>
            <td>
                <div class="d-flex justify-content-end">
                    <ng-container *ngIf="row.status === 'pendingApprovation'; else acceptedRejected">
                        <button class="btn btn-light me-2" type="button"
                                [disabled]="isCompanyApprovalBusy(row.id)"
                                (click)="approveCompany(row.id)">
                            <span *ngIf="isCompanyApprovalBusy(row.id)"
                                  class="spinner-border spinner-border-sm" role="status"></span>
                            <svg *ngIf="!isCompanyApprovalBusy(row.id)"
                                 xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-check-lg" viewBox="0 0 16 16">
                                <path
                                        d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                            </svg>
                        </button>
                        <button class="btn btn-light " type="button"
                                [disabled]="isCompanyApprovalBusy(row.id)"
                                (click)="refuseCompany(row.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path
                                        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                            </svg>
                        </button>
                    </ng-container>
                    <ng-template #acceptedRejected>
                        <div style="height: 38px;">
                            <button class="btn welldone-btn-light me-2" (click)="sendApprovalEmail(row.id)">
                                Invia Onboarding
                            </button>
                        </div>
                    </ng-template>
                </div>
            </td>
        </tr>
    </ng-template>
        </ui-table>
    </div>
</div>

<div class="bg-white table-radius shadow-sm mb-2 collapsible-dash-table">
    <div class="d-flex justify-content-between align-items-center table-text-custom" (click)="collapseAgentsTable = !collapseAgentsTable">
        <div class="d-flex flex-column justify-content-start">
            <span class="table-title-custom mb-0">Agenti in attesa di approvazione</span>
            <span class="table-desc-custom mt-1">In questa lista ci sono tutti gli agenti in attesa di essere 'Attivati'.</span>
        </div>
        <i class="bi" [ngClass]="collapseAgentsTable ? 'bi-chevron-down' : 'bi-chevron-up'" style="font-size: 1.2rem; font-weight: bold; cursor: pointer;"></i>
    </div>
    <div [hidden]="collapseAgentsTable">
        <ui-table #agentsTable class="no-box-model">
    <ng-template #customHeader>
        <tr>
            <th>Ragione sociale</th>
            <th>Data richiesta</th>
            <th>Agente</th>
            <th>Partita IVA</th>
            <th>Recapiti</th>
            <th scope="col" class="d-flex justify-content-end pe-5"> Azioni</th>
        </tr>
    </ng-template>

    <ng-template #customRow let-row="row">
        <tr>
            <td>
                {{ row.businessName }}
            </td>
            <td> {{ formatDateForTable(row.createdAt) }}</td>
            <td> {{ row.firstName }} {{ row.lastName }}</td>
            <td> {{ row.vat }}</td>
            <td>
                <div class="mb-2">{{ row.email }}</div>
                <div>{{ row.phone }}</div>
            </td>
            <td>
                <div class="d-flex justify-content-end">
                    <button class="btn welldone-btn-success me-2" (click)="approveAgent(row.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-check-lg" viewBox="0 0 16 16">
                            <path
                                    d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        </svg>
                    </button>
                    <button class="btn welldone-btn-danger"
                            (click)="rejectAgent(row.id)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                            <path
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                        </svg>
                    </button>

                </div>
            </td>
        </tr>
    </ng-template>
        </ui-table>
    </div>
</div>
</div>
